import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import {
  dataAlumnosExamenes,
  updateAverageEscrito,
  updateAverageGeneral,
  updateAverageOral
} from 'data/apiConection.js/dataAlumnos';
import { columnsCuotas2025 } from 'components/dashboards/support-desk/unsolved-tickets/TicketsLayout';
import { dataCursos, dataCursosNiveles } from 'data/apiConection.js/dataCursos';
import { getUsers } from 'data/apiConection.js/dataUsers';
import DealStorageFunnel from 'components/dashboards/crm/deal-storage-funnel/DealStorageFunnel';

const TableViewCuotas2025 = () => {
  const [alumnos, setAlumnos] = useState([]);
  const [filteredAlumnos, setFilteredAlumnos] = useState([]);
  const [filter, setFilter] = useState('');
  const [cursos, setCursos] = useState([]);
  const [cursosSinLimite, setCursosSinLimite] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = await getUsers();
        const cu = await dataCursosNiveles();
        const cuSL = await dataCursos();
        const cuSLF = cuSL.filter(curso => curso.cupo_maximo > 0);
        if (user?.role === 'teacher' && user?.profesor_id) {
          const cuByProfesor = cu.filter((curso) => curso.profesor_id === user.profesor_id);
          setCursos(cuByProfesor);
        } else {
          setCursos(cu);
          setCursosSinLimite(cuSLF);
          console.log(cursosSinLimite);
        }
      } catch (error) {
        console.error('Error fetching cursos:', error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await updateAverageOral();
        await updateAverageEscrito();
        await updateAverageGeneral();
        const al = await dataAlumnosExamenes('2025');
        setAlumnos(al);
        setFilteredAlumnos(al); // Mantén copia original para filtrar
      } catch (error) {
        console.error('Error fetching alumnos:', error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (filter.trim() === '') {
      setFilteredAlumnos(alumnos);
      return;
    }

    const value = filter.toLowerCase();
    const alumnosFiltrados = alumnos.filter(alumno =>
      (alumno.dni && alumno.dni.toLowerCase().includes(value)) ||
      (alumno.firstName && alumno.firstName.toLowerCase().includes(value)) ||
      (alumno.lastName && alumno.lastName.toLowerCase().includes(value))
    );
    setFilteredAlumnos(alumnosFiltrados);
  }, [filter, alumnos]);

  const columns = columnsCuotas2025(cursos);

  return (
    <div>
      <Row className="mb-3">
        <Col>
          <label>Filtro</label>
          <input
            title='Filtro por DNI , nombre o apellido ...'
            type="text"
            placeholder="Buscar por DNI, Nombre o Apellido..."
            className="form-control"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />
        </Col>
      </Row>

      <Row
        className="gx-4 mx-0"
        style={{
          height: '100vh',
          width: '100%',
          marginLeft: '250px',
          padding: '20px',
        }}
      >
        <Col lg={12} style={{ height: '30%', width: "100%" }}>
          <DealStorageFunnel />
        </Col>

        {filteredAlumnos && (
          <Col style={{ height: '70%' }}>
            <AdvanceTableWrapper
              columns={columns}
              data={filteredAlumnos}
              selection
              selectionColumnWidth={52}
              sortable
              pagination
              perPage={100}
              rowCount={filteredAlumnos.length}
            >
              <Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Card.Body className="p-3" style={{ flexGrow: 1, overflowY: 'auto' }}>
                  <AdvanceTable
                    table
                    headerClassName="bg-light text-800 align-middle"
                    rowClassName="btn-reveal-trigger align-middle"
                    tableProps={{
                      size: 'sm',
                      className: 'fs--1 mb-0 w-100 h-100',
                    }}
                  />
                </Card.Body>
                <Card.Footer>
                  <AdvanceTablePagination table />
                </Card.Footer>
              </Card>
            </AdvanceTableWrapper>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default TableViewCuotas2025;

